import React, {Component} from 'react';
import { registerReactApp, reactAppLoaded } from '../services/reactLoadTracker';
import TravelAreaSelector from '../components/Planner/TravelAreaSelector';
import PropTypes from 'prop-types';
import * as api from '../services/api';
import * as router from '../services/frontendRouter';
import * as mapper from '../services/teaserMapper';
import ItineraryItem from '../components/Favourites/ItineraryItem';
import PaginationControl from "../components/Filter/PaginationControl";
import IndependentSelector from "../components/Planner/IndependentSelector";
import translate from '../services/translation';
import TeaserList from '../components/TeaserList/TeaserList';
import SortingSelector from "../components/Planner/SortingSelector";
import _ from 'lodash';
import ResetButton from "../components/Planner/ResetButton";
import * as travelAreaSelection from '../services/travelAreaSelection';
import IndependentMultiSelector from "../components/Planner/IndependentMultiSelector";
import ParentDependentMultiSelect from "../components/Planner/ParentDependentMultiSelect";
import SeasonSelector from "../components/Planner/SeasonSelector";
import PlannerListLayout from "../components/Planner/PlannerListLayout";
import TeaserItem from "../components/Favourites/TeaserItem";
import PrintPlannerList from "../components/Planner/PrintPlannerList";

export class PlannerListApp extends Component {

    static propTypes = {
        layout: PropTypes.string,
        travelAreaCountriesPreset: PropTypes.array,
        travelAreaPreset: PropTypes.number,
        travelTypePreset: PropTypes.string,
        travelCategoryPreset: PropTypes.string,
        selectedChannelPreset: PropTypes.string,
        monthsPreset: PropTypes.string,
        travelLabelPreset: PropTypes.string,
        shipPreset: PropTypes.number,
        itineraryPrintBaseUrl: PropTypes.string,
        itineraryPrintListUrl: PropTypes.string,
        itineraryPrintTeaserUrl: PropTypes.string,
        favouriteLink: PropTypes.string
    };

    static initialLimit = 12;
    static alternativeLimit = 4;
    static defaultSorting = 'commercialPriority_intS';
    static defaultSortingDirection = 'asc';

    initialState = {
        filter: {
            travelAreaCountry: this.props.travelAreaCountriesPreset.length !== 0 ? this.props.travelAreaCountriesPreset : router.getParamFromUrl('travelAreaCountry') ? router.getParamFromUrl('travelAreaCountry').split(',').map(item => parseInt(item, 10)) : [],
            travelAreaRegion: this.props.travelAreaPreset ? this.props.travelAreaPreset : router.getParamFromUrl('travelAreaRegion'),
            travelAreaDestination: this.props.travelAreaPreset ? this.props.travelAreaPreset : router.getParamFromUrl('travelAreaDestination'),
            travelLabel: this.props.travelLabelPreset !== '' ? this.props.travelLabelPreset : router.getParamFromUrl('travelLabel'),
            travelType: this.props.travelTypePreset !== '' ? this.props.travelTypePreset.split(',') : router.getParamFromUrl('travelType') ? router.getParamFromUrl('travelType').split(',') : [],
            travelCategory: this.props.travelCategoryPreset !== '' ? this.props.travelCategoryPreset.split(',') : router.getParamFromUrl('travelCategory') ? router.getParamFromUrl('travelCategory').split(',') : [],
            selectedChannel: this.props.selectedChannelPreset !== '' ? this.props.selectedChannelPreset : router.getParamFromUrl('selectedChannel'),
            year: router.getParamFromUrl('year') ? router.getParamFromUrl('year') : 0,
            timeOfYear: router.getParamFromUrl('timeOfYear') ? router.getParamFromUrl('timeOfYear', ) : 0,
            month: this.props.monthsPreset !== '' ? this.props.monthsPreset.split(',') : router.getParamFromUrl('month') ? router.getParamFromUrl('month').split(',') : [],
            limit: parseInt(router.getParamFromUrl('limit', PlannerListApp.initialLimit), 10),
            offset: router.getParamFromUrl('offset'),
            sortBy: router.getParamFromUrl('sortBy') ? router.getParamFromUrl('sortBy') : 'commercialPriority_intS',
            sortDirection: router.getParamFromUrl('sortDirection') ? router.getParamFromUrl('sortDirection') : 'asc',
            ship: this.props.shipPreset !== '' ? this.props.shipPreset : router.getParamFromUrl('ship'),

        },
        fixedTravelAreaLevel: 0,
        itineraries: [],
        alternativeItineraries: [],
        labels: [],
        types: [],
        categories: [],
        years: [],
        months: [],
        countries: [],
        regions: [],
        destinations: [],
        filterListMenu: false,
        loading: false,
        currentLayout: 'list'
    };

    constructor(props) {
        super(props);

        this.fetchOptionsData();

        this.state = this.initialState;
    }

    updateFilter = (event) => {
        let castValue;

        if (Array.isArray(event.target.value)) {
            castValue = event.target.value;
        } else {
            castValue = isNaN(event.target.value) ? event.target.value : parseInt(event.target.value, 10);
        }

        let newFilter;

        if (event.target.hasOwnProperty('timeOfYear')) {
            newFilter = {...this.state.filter, [event.target.name]: castValue, timeOfYear: event.target.timeOfYear, limit: PlannerListApp.initialLimit, offset: 0};
        } else {
            newFilter = {...this.state.filter, [event.target.name]: castValue, limit: PlannerListApp.initialLimit, offset: 0};
        }

        if (event.target.month) {
            newFilter.month = event.target.month
        }

        if (event.target.name === 'travelAreaCountry') {
            newFilter.travelAreaRegion = 0;
            newFilter.travelAreaDestination = 0;
        }

        if (event.target.name === 'travelAreaRegion') {
            newFilter.travelAreaDestination = 0;
        }

        if (event.target.name === 'travelType') {
            newFilter.travelCategory = newFilter.travelCategory.filter(categoryName => {

                const category = this.state.categories.find(category => {
                    return category.uid === categoryName;
                })

                const selectedParentTypes = category.parents.filter(type => {
                    return newFilter.travelType.includes(type);
                })

                return selectedParentTypes.length > 0;
            });
        }

        this.setState({filter: newFilter}, () => {
            this.fetchItineraries();
            router.updateUrl(this.state.filter);
        })
    };

    updateSorting = (field, value) => {
        const newFilter = {...this.state.filter, [field]: value};
        this.setState({filter: newFilter}, () => {
            this.fetchItineraries();
            router.updateUrl(this.state.filter);
        })
    };

    resetCompleteForm = () => {
        this.setState({filter: this.getEmptyFilter()}, () => {
            this.fetchItineraries();
            router.updateUrl(this.state.filter);
        });
    };

    resetFilterValue = (key) => {
        let event = {target: {}};

        if (key === 'year') {
            event.target.name = key;
            event.target.value = this.emptyFilter[key];
            event.target.timeOfYear = this.emptyFilter['timeOfYear'];
            event.target.month = this.emptyFilter['month'];
        } else {
            event.target.name = key;
            event.target.value = this.emptyFilter[key];
        }

        this.updateFilter(event);
    };

    loadMore = () => {
        const newFilter = {
            ...this.state.filter,
            limit: parseInt(this.state.filter.limit,10) + PlannerListApp.initialLimit,
            offset: parseInt(this.state.filter.offset,10) + PlannerListApp.initialLimit
        };

        this.setState({filter: newFilter}, () => {
            this.fetchItineraries(true);
            router.updateUrl(this.state.filter);
        })
    };

    fetchItineraries = (append = false) => {
        this.setState({loading: true});

        api.getItinerariesByFilter(this.state.filter).then(
            response => {
                if(append) {
                    const newItineraries = this.state.itineraries.concat(response.data);
                    this.setState({itineraries: newItineraries});
                } else {
                    if(response.data.length !== 0) {
                        this.setState({itineraries: response.data});
                    } else {
                        if(this.state.alternativeItineraries.length === 0) {
                            const emptyFilter = {...this.getEmptyFilter()};
                            emptyFilter.travelAreaCountry = [];
                            emptyFilter.travelType = [];
                            emptyFilter.travelCategory = [];
                            emptyFilter.limit = PlannerListApp.alternativeLimit;

                            api.getItinerariesByFilter(emptyFilter).then(
                                response => {
                                    this.setState({itineraries: [], alternativeItineraries: response.data});
                                },
                                error => {
                                    console.error(error.message);
                                }
                            )
                        } else {
                            this.setState({itineraries: []});
                        }
                    }
                }
                this.setState({loading: false}, () => {
                    if (!this._trackerDone) {
                        this._trackerDone = true;
                        reactAppLoaded();
                    }
                });
            },
            error => {
                console.error(error.message);
                this.setState({loading: false}, () => {
                    if (!this._trackerDone) {
                        this._trackerDone = true;
                        reactAppLoaded();
                    }
                });
            }
        )
    };

    fetchOptionsData = () => {
        this.fetchTravelAreas(2, 'countries');
        this.fetchTravelAreas(3, 'regions');
        this.fetchTravelAreas(4, 'destinations');
        this.fetchTags('ItineraryLabelsKontiki', 'labels');
        this.fetchTags('ItineraryTypeKontiki', 'types');
        this.fetchTags('ItinerarySegmentationKontiki', 'categories');
        this.fetchOptions('seasons', 'years');
        this.fetchOptions('months', 'months');
    };

    fetchTags = (clvType, stateField) => {
        api.getTagsByClvType(clvType).then(
            response => {
                this.setState({[stateField]: response.data})
            }
        )
    };

    fetchOptions = (clvType, stateField) => {
        api.getOptionsByClvType(clvType).then(
            response => {
                this.setState({[stateField]: response.data})
            }
        )
    };

    fetchTravelAreas = (depth, stateField) => {
        api.getTravelAreasByDepth(depth).then(
            response => {
                this.setState({[stateField]: response.data}, () => {
                    if(this.props.travelAreaCountriesPreset.length !== 0 || this.props.travelAreaPreset !== 0) {
                        const selectedTravelAreas = travelAreaSelection.constructSelectedOptionsFromUid(
                            this.props.travelAreaCountriesPreset,
                            this.props.travelAreaPreset,
                            this.state.countries,
                            this.state.regions,
                            this.state.destinations
                        );

                        const newFilter = {...this.state.filter, travelAreaCountry: selectedTravelAreas.selectedCountry, travelAreaRegion: selectedTravelAreas.selectedRegion, travelAreaDestination: selectedTravelAreas.selectedDestination};
                        const travelAreaFixedLevel = travelAreaSelection.calculateFixedTravelAreaLevel(newFilter);

                        this.setState({filter: newFilter, travelAreaFixedLevel: travelAreaFixedLevel});
                    }
                });
            }
        )
    };

    switchLayout = (layout) => {
        this.setState({currentLayout: layout})
    }

    componentDidMount() {
        registerReactApp();
        this.fetchItineraries();
        const anchor = window.location.hash.slice(1);

        if (anchor) {
            setTimeout(() => {
                const anchorEl = document.getElementById(anchor);

                if (anchorEl) {
                    anchorEl.scrollIntoView({behavior: "smooth"});
                }
            }, 1500);
        }

    }

    render() {
        const {itineraries, filter, labels, types, years, months, categories, countries, regions, destinations, travelAreaFixedLevel, loading, alternativeItineraries, currentLayout} = this.state;
        const {layout, travelAreaPreset, travelAreaCountriesPreset, travelTypePreset, travelCategoryPreset, monthsPreset, travelLabelPreset,
            itineraryPrintBaseUrl, itineraryPrintListUrl, itineraryPrintTeaserUrl, favouriteLink} = this.props;

        return (
            <div className={'plannerListAppContainer'}>

                <div className={'filterListMenu d-block d-lg-none'} onClick={ () => this.setState({filterListMenu: !this.state.filterListMenu}) }>{translate('filter_mobile.toggle.label')}</div>

                <div className={'filterListContainer' + (this.state.filterListMenu === true ? ' open' : '') + (itineraries.length === 0 ? ' filterNoResults' : '')}>

                    <div className={'plannerFilterRow'}>
                        <TravelAreaSelector
                            selectedCountry={filter.travelAreaCountry}
                            selectedRegion={parseInt(filter.travelAreaRegion, 10)}
                            selectedDestination={parseInt(filter.travelAreaDestination, 10)}
                            countries={countries}
                            regions={regions}
                            destinations={destinations}
                            onChange={this.updateFilter}
                            fixedTravelAreaLevel={travelAreaFixedLevel}
                            hasSpecialIcon={true}
                            resetFunction={this.resetFilterValue}
                            disabled={travelAreaCountriesPreset.length === 0 && travelAreaPreset === 0}
                            listType={'itinerary'}
                        />
                    </div>

                    <div className={'plannerFilterRow'}>
                        <div className={'selectCustom'}>
                            <IndependentMultiSelector name="travelType"
                                                 selectedOptions={filter.travelType}
                                                 options={types}
                                                 defaultOptionLabel={translate('planner_list.choose_type')}
                                                 onChange={this.updateFilter}
                                                 disabled={travelTypePreset !== ''}
                                                 hasSpecialIcon={true}
                                                 resetFunction={this.resetFilterValue}
                            />
                        </div>
                        <ParentDependentMultiSelect
                            name="travelCategory"
                            defaultOptionLabel={translate('planner_list.choose_category')}
                            options={categories}
                            selectedOptions={filter.travelCategory}
                            selectedParents={filter.travelType}
                            onChange={this.updateFilter}
                            disabled={travelCategoryPreset !== ''}
                            hasSpecialIcon={true}
                            resetFunction={this.resetFilterValue}

                        />
                    </div>

                    <div className={'plannerFilterRow'}>
                        {monthsPreset === '' &&
                            <SeasonSelector
                                name="year"
                                defaultOptionLabel={translate('planner_list.choose_season')}
                                years={years}
                                months={months}
                                selectedYear={filter.year}
                                timeOfYear={filter.timeOfYear}
                                selectedMonths={filter.month}
                                onChange={this.updateFilter}
                                hasSpecialIcon={true}
                                resetFunction={this.resetFilterValue}
                            />
                        }
                        {filter.year !== 0 &&
                            <ResetButton itineraries={itineraries} loading={loading} reset={this.resetFilterValue} value={filter.year} filterKey="year" />
                        }

                        {monthsPreset !== '' &&
                            <IndependentMultiSelector
                              name="month"
                              selectedOptions={filter.month}
                              options={months}
                              defaultOptionLabel={translate('planner_list.choose_month')}
                              onChange={this.updateFilter}
                              resetFunction={this.resetFilterValue}
                              disabled={monthsPreset !== ''}
                              hasSpecialIcon={true}
                            />
                        }
                    </div>

                    <div className={'plannerFilterRow'}>
                        <IndependentSelector name="travelLabel"
                                             selectedOption={filter.travelLabel}
                                             options={labels}
                                             defaultOptionLabel={translate('planner_list.choose_label')}
                                             onChange={this.updateFilter}
                                             hasSpecialIcon={true}
                                             disabled={travelLabelPreset !== ''}
                        />
                        {travelLabelPreset === '' &&
                            <ResetButton itineraries={itineraries} loading={loading} reset={this.resetFilterValue} value={filter.travelLabel} filterKey="travelLabel" />
                        }
                    </div>
                </div>

                <div className={'filterSortContainer'}>
                    <div className={'resetFilterButtonContainer'}>
                        {!_.isEqual(filter, this.getEmptyFilter()) &&
                        <button onClick={this.resetCompleteForm}>
                            {translate('planner_list.reset_filter')}
                        </button>
                        }
                    </div>

                    <div className={'plannerSortingRow'}>
                        <SortingSelector
                            sortBy={filter.sortBy}
                            sortDirection={filter.sortDirection}
                            handleSortingChange={this.updateSorting}
                            defaultSortingValue="commercialPriority_intS"
                            priceSortingValue="price_intS"
                            durationSortingValue="numberofdays_intS"
                        />
                    </div>
                </div>

                <div className="plannerLayoutContainer">
                    {layout !== 'tile' &&
                        <PrintPlannerList
                            currentLayout={currentLayout}
                            layout={layout}
                            filename={translate('itinerary_list.print.list.name')}
                            selectedSeason={filter.year}
                            selectedMonths={filter.month}
                            selectedWeekdays={[]}
                            selectedCategory={filter.travelCategory}
                            selectedType={filter.travelType}
                            selectedCountry={filter.travelAreaCountry}
                            selectedRegion={parseInt(filter.travelAreaRegion, 10)}
                            selectedDestination={parseInt(filter.travelAreaDestination, 10)}
                            selectedLabel={filter.travelLabel}
                            sortBy={filter.sortBy}
                            sortDirection={filter.sortDirection}
                            plannerPrintBaseUrl={itineraryPrintBaseUrl}
                            plannerPrintListUrl={itineraryPrintListUrl}
                            plannerPrintTeaserUrl={itineraryPrintTeaserUrl}
                            listType={'itinerary'}
                            limit={parseInt(filter.limit, 10)}
                        />
                    }

                    {!layout && <PlannerListLayout switchLayout={this.switchLayout} currentLayout={currentLayout} mapLayout={false} />}
                </div>

                {layout === '' &&
                    <div className={'plannerListContainer' + (currentLayout === 'list' ? '' : itineraries.length === 0 ? '' : ' plannerListTeaserContainer row')}>
                        {currentLayout === 'list' && itineraries && itineraries.map(itinerary => <ItineraryItem key={itinerary.uid} favouriteItem={itinerary} favouriteLink={favouriteLink}/>)}
                        {currentLayout === 'compare' && itineraries && itineraries.map(itinerary => <TeaserItem key={itinerary.uid} favouriteItem={itinerary} type={'itinerary'} favouriteLink={favouriteLink}/>)}

                        {itineraries.length === 0 && !loading &&
                            <div>
                                <div className={'plannerNoResults'}>{translate('planner_list.no_results')}</div>
                                <div className={'alternativeItinerariesTitle'}><h2>{translate('planner_list.alternative_title')}</h2></div>

                                <div className={currentLayout === 'compare' ? ' row' : ''}>
                                    {alternativeItineraries.map(itinerary => currentLayout === 'list' ? <ItineraryItem key={itinerary.uid} favouriteItem={itinerary} favouriteLink={favouriteLink}/> : <TeaserItem key={itinerary.uid} favouriteItem={itinerary} type={'itinerary'} favouriteLink={favouriteLink}/> )}
                                </div>
                            </div>
                        }
                    </div>
                }

                {layout === 'list' &&
                    <div className={'plannerListContainer'}>
                        {itineraries && itineraries.map(itinerary => <ItineraryItem key={itinerary.uid} favouriteItem={itinerary} favouriteLink={favouriteLink}/>)}
                        {itineraries.length === 0 && !loading &&
                            <div>
                                <div className={'plannerNoResults'}>{translate('planner_list.no_results')}</div>
                                <div className={'alternativeItinerariesTitle'}><h2>{translate('planner_list.alternative_title')}</h2></div>
                                {alternativeItineraries.map(itinerary => <ItineraryItem key={itinerary.uid} favouriteItem={itinerary} favouriteLink={favouriteLink}/>)}
                            </div>
                        }
                    </div>
                }

                {layout === 'compare' &&
                    <div className={'plannerListContainer' + (itineraries.length === 0 ? '' : ' plannerListTeaserContainer row')}>
                        { itineraries && itineraries.map(itinerary => <TeaserItem key={itinerary.uid} favouriteItem={itinerary} type={'itinerary'} favouriteLink={favouriteLink}/>) }
                        {itineraries.length === 0 && !loading &&
                            <div>
                                <div className={'plannerNoResults'}>{translate('planner_list.no_results')}</div>
                                <div className={'alternativeItinerariesTitle'}><h2>{translate('planner_list.alternative_title')}</h2></div>
                                <div className={'row'}>
                                    {alternativeItineraries.map(itinerary => <TeaserItem key={itinerary.uid} favouriteItem={itinerary} type={'itinerary'} favouriteLink={favouriteLink}/>)}
                                </div>
                            </div>
                        }
                    </div>
                }

                {layout === 'tile' && <div>{itineraries && <TeaserList teasers={itineraries.map(itinerary => mapper.mapItineraryToTeaser(itinerary))}/>}</div>}

                {itineraries.length > 0 && itineraries.length === parseInt(this.state.filter.limit,10) ?
                    <PaginationControl paginate={this.loadMore} /> : ''
                }
            </div>
        );
    }

    getEmptyFilter = () => {
        const emptyFilter = this.emptyFilter;
        if(this.props.travelAreaCountriesPreset.length !== 0 || this.props.travelAreaPreset !== 0) {
            const selectedTravelAreas = travelAreaSelection.constructSelectedOptionsFromUid(
                this.props.travelAreaCountriesPreset,
                this.props.travelAreaPreset,
                this.state.countries,
                this.state.regions,
                this.state.destinations
            );
            emptyFilter.travelAreaCountry = selectedTravelAreas.selectedCountry;
            emptyFilter.travelAreaRegion = selectedTravelAreas.selectedRegion;
            emptyFilter.travelAreaDestination = selectedTravelAreas.selectedDestination;
        }

        return emptyFilter;
    };

    emptyFilter =  {
        travelAreaCountry: this.props.travelAreaCountriesPreset.length !== 0 ? this.props.travelAreaCountriesPreset : [],
        travelAreaRegion: 0,
        travelAreaDestination: 0,
        travelLabel: this.props.travelLabelPreset !== '' ? this.props.travelLabelPreset : 0,
        travelType: this.props.travelTypePreset !== '' ? this.props.travelTypePreset.split(',') : [],
        travelCategory: this.props.travelCategoryPreset !== '' ? this.props.travelCategoryPreset.split(',') : [],
        selectedChannel: this.props.selectedChannelPreset !== '' ? this.props.selectedChannelPreset : 0,
        year: 0,
        timeOfYear: 0,
        month: this.props.monthsPreset !== '' ? this.props.monthsPreset.split(',') : [],
        limit: PlannerListApp.initialLimit,
        offset: 0,
        sortBy: PlannerListApp.defaultSorting,
        sortDirection: PlannerListApp.defaultSortingDirection,
        ship: this.props.shipPreset !== '' ? this.props.shipPreset : 0,
    };
}

PlannerListApp.defaultProps = {
    layout: 'list',
    travelAreaCountriesPreset: [],
    travelAreaPreset: 0,
    travelTypePreset: '',
    travelLabelPreset: '',
    shipPreset: 0
};



// WEBPACK FOOTER //
// ./src/apps/PlannerListApp.js